import React from 'react';
import PropTypes from 'prop-types';

import styles from './main-layout.scss';

const MainLayout = ({ children, handleSitePusherClick, isHeaderOpen }) => (
  <div className={styles.bodyContainer}>
    <div className={styles.sitePusher}>
      {/* eslint-disable jsx-a11y/no-static-element-interactions */}
      <div
        className={styles.pageContainer}
      >
        {children}
        <div
          className={styles.veil}
          onClick={event => handleSitePusherClick(event, isHeaderOpen)}
        />
      </div>
      {/* eslint-enable */}
    </div>
  </div>
);

MainLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element.isRequired),
    PropTypes.element,
  ]).isRequired,
  handleSitePusherClick: PropTypes.func.isRequired,
  isHeaderOpen: PropTypes.bool.isRequired,
};

export default MainLayout;



// WEBPACK FOOTER //
// ./common/components/MainLayout/component.js